/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'placeholder': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M4.75 10c0-2.323.823-4.12 2.11-5.338C8.15 3.437 9.958 2.75 12 2.75c2.041 0 3.849.687 5.14 1.912C18.428 5.88 19.25 7.677 19.25 10c0 1.625-.99 3.608-2.377 5.547-1.363 1.906-3.01 3.636-4.125 4.726a1.057 1.057 0 01-1.496 0c-1.115-1.09-2.762-2.82-4.125-4.726C5.74 13.607 4.75 11.625 4.75 10zM12 1.25c-2.377 0-4.57.803-6.173 2.323C4.217 5.099 3.25 7.302 3.25 10c0 2.128 1.245 4.445 2.657 6.42 1.436 2.007 3.152 3.806 4.296 4.925a2.557 2.557 0 003.594 0c1.144-1.119 2.86-2.918 4.296-4.925 1.412-1.975 2.657-4.292 2.657-6.42 0-2.698-.968-4.901-2.577-6.427C16.569 2.053 14.377 1.25 12 1.25zM9.75 10a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM12 6.25a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z" _fill="#000"/>'
  }
})
